// Added by Sejune Oh on 2020-04-07
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React from 'react'
import { createStyles, Theme, makeStyles, useTheme } from '@material-ui/core'

import { TableCell, TableHead, TableRow, TableSortLabel } from '@/components/_primes/v2'

import { Column } from './Table'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export type Order = 'asc' | 'desc'

interface EnhancedTableProps {
  onRequestSort: (event: React.MouseEvent<unknown>, property: string) => void
  order: Order
  orderBy: string
  headCells: Column[]
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const EnhancedTableHead = ({ headCells, order, orderBy, onRequestSort }: EnhancedTableProps) => {
  const classes = useStyles(useTheme())

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  const createSortHandler = (property: string) => (event: React.MouseEvent<unknown>) => {
    onRequestSort(event, property)
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  return (
    <TableHead>
      <TableRow className={classes.row}>
        {headCells.map(({ id, align, disablePadding, label, sortable }) => {
          if (!sortable)
            return (
              <TableCell
                key={id}
                align={align}
                padding={disablePadding ? 'none' : 'normal'}
                sortDirection={orderBy === id ? order : false}
                data-sortable={"false"}
              >
                {label}
              </TableCell>
            )

          return (
            <TableCell
              key={id}
              align={align}
              padding={disablePadding ? 'none' : 'normal'}
              sortDirection={orderBy === id ? order : false}
              data-sortable={"true"}
            >
              <TableSortLabel
                active={orderBy === id}
                direction={orderBy === id ? order : 'desc'}
                onClick={createSortHandler(id)}
              >
                {label}
                {orderBy === id ? (
                  <span className={classes.visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </span>
                ) : null}
              </TableSortLabel>
            </TableCell>
          )
        })}
      </TableRow>
    </TableHead>
  )
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    row: {
      '& > th': {
        backgroundColor: 'rgb(66, 66, 66)',
      }
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
    },
  })
)

export default EnhancedTableHead
